import React from "react";
import PropTypes from "prop-types";
import CalculatorInput from "./CalculatorInput";
import { WEIGHT_UNITS } from "../../utils/calculators/constants";

const WeightInputGroup = ({
  label = "Actual body weight",
  idPrefix,
  weightValue,
  weightUnit,
  onWeightChange,
  onWeightUnitChange,
  error,
  unitOptions = WEIGHT_UNITS,
  inputProps = {},
  isWebLayout = false,
  "data-testid": dataTestId = "weight-input",
}) => {
  const defaultInputProps = {
    type: "number",
    min: 0,
    autoComplete: "off",
    "data-testid": dataTestId,
    ...inputProps,
  };

  return (
    <CalculatorInput
      label={label}
      id={`${idPrefix}-weight`}
      value={weightValue}
      onChange={onWeightChange}
      error={error}
      unitOptions={unitOptions}
      unitValue={weightUnit}
      onUnitChange={onWeightUnitChange}
      inputProps={defaultInputProps}
      isWebLayout={isWebLayout}
    />
  );
};

WeightInputGroup.propTypes = {
  label: PropTypes.string,
  idPrefix: PropTypes.string.isRequired,
  weightValue: PropTypes.string.isRequired,
  weightUnit: PropTypes.string.isRequired,
  onWeightChange: PropTypes.func.isRequired,
  onWeightUnitChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  unitOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      shortLabel: PropTypes.string,
    })
  ),
  inputProps: PropTypes.object,
  isWebLayout: PropTypes.bool,
  "data-testid": PropTypes.string,
};

export default WeightInputGroup;
